<script lang="ts" setup>
import { storeToRefs } from 'pinia'

import { TOP_CONTENT_VISIBLE_ROUTES } from '@/constants/topContentVisibleRoutes'

import { useBasketMethods } from '@/composables/useBasketMethods'
import { useContentVisibleByRoute } from '@/composables/useContentVisibleByRoute'

import { useAddressSystemStore } from '@/store/addressSystem'
import { useToggleStore } from '@/store/toggle/toggle'

import { VkAuthType } from '@/services/vkAuth/vkAuth.types'

import TheCookiesBanner from '@/components/App/AppCookiesBanner.vue'
import TheFooter from '@/components/Footer/TheFooter.vue'
import TheHeader from '@/components/Header/TheHeader.vue'

const MainCategoryList = defineAsyncComponent(
  () => import('@/components/Main/MainCategoryList.vue'),
)
const AppSnackbar = defineAsyncComponent(
  () => import('@/components/App/AppSnackbar.vue'),
)
const MainDialogWorking = defineAsyncComponent(
  () => import('@/components/Main/MainDialogWorking.vue'),
)

const { isVisibleStories } = storeToRefs(useToggleStore())

const { fetchBasket, handleRedirectCity } = useBasketMethods()

const { setVkFrame } = useVkAuth(VkAuthType.WINDOW)

const { setVisibleAddressSystemDialog } = useAddressSystemStore()
const { isVisibleAddressSystemDialog } = storeToRefs(useAddressSystemStore())

const { isVisible } = useContentVisibleByRoute(TOP_CONTENT_VISIBLE_ROUTES)

const closeAddressSystemDialog = () => {
  setVisibleAddressSystemDialog(false)
  isVisibleAddressSystemDialog.value = false
}

onMounted(async () => {
  await fetchBasket()

  await handleRedirectCity()

  setVkFrame(document.body)
})
</script>

<template>
  <div class="default">
    <the-header />

    <main class="wrapper">
      <app-snackbar />

      <app-stories v-if="isVisible && isVisibleStories" class="stories" />

      <main-category-list v-if="isVisible" class="list-categories" />

      <div class="page">
        <slot />
      </div>

      <main-dialog-working />

      <address-system-dialog
        v-if="isVisibleAddressSystemDialog"
        :model-value="isVisibleAddressSystemDialog"
        @update:model-value="closeAddressSystemDialog"
      />
    </main>

    <the-footer />

    <client-only>
      <the-cookies-banner />
    </client-only>
  </div>
</template>

<style lang="scss" scoped>
.default {
  background: var(--ui-white);
}

:deep(.page) {
  min-height: calc(100vh - 118px);
}
.list-categories {
  padding: 0 calc((50% - 600px)) 0;
}

.stories {
  padding: 0 calc((100% - 1200px) / 2) 0;
  margin-top: 30px;
}

.wrapper {
  position: relative;
}
</style>
